const sortOptions = (rawData, preventSort) => {
  if (rawData?.message === "No record in DataBase!") {
    return [];
  } else {
    const data = rawData?.page ? rawData?.page : rawData;
    let enhancedRawData = data;
    const filD = data?.filter((each) => each !== null);
    if (filD?.length > 0) {
      if (typeof filD[0] === "object") {
        enhancedRawData = data
          ?.filter((each) => each !== null)
          .map((each) => {
            let copiedEach = { ...each };
            if (copiedEach?.name === null) {
              copiedEach.name = "";
            }
            if (copiedEach?.title === null) {
              copiedEach.title = "";
            }
            return copiedEach;
          });
      } else if (typeof filD[0] === "string") {
        enhancedRawData = data?.filter((each) => each !== null);
      }
      let sortedData;
      if (preventSort) {
        sortedData = enhancedRawData;
      } else {
        sortedData = enhancedRawData.sort((a, b) => {
          if (typeof a === "object") {
            if (a.name || a.name === "") {
              return a.name.localeCompare(b.name);
            } else if (a.title || a.title === "") {
              return a.title.localeCompare(b.title);
            } else if (a.code || a.code === "") {
              return a.code.localeCompare(b.code);
            } else if (a.id || a.id === "") {
              return a.id.localeCompare(b.id);
            }
          } else if (typeof a === "string") {
            return a.localeCompare(b);
          } else {
            return;
          }
        });
      }
      return sortedData;
    } else {
      return [];
    }
  }
};

export default sortOptions;
